import { Component, Input } from '@angular/core';
import { Project } from '../../project.model';
import { environment } from 'src/environments/environment';
import { AddProjectPartDialogComponent } from '../add-project-part-dialog/add-project-part-dialog.component';
import { ArticleTypeService } from 'src/erp-articles/article-types/article-type.service';
import { TranslationService } from '@sdbn/common';
import { ConfigurationService, DialogService, HttpService } from '@sdbn/appclient';

@Component({
  selector: 'app-project-details',
  templateUrl: './project-details.component.html',
  styleUrls: ['./project-details.component.scss']
})
export class ProjectDetailsComponent {
  isLoading = false;
  projectId: number;
  project: Project;

  @Input('projectId') set setProjectId(projectId: number) {
    this.projectId = projectId;
    this.readProject();
  }

  constructor(
    public articleTypeService: ArticleTypeService,
    public configurationService: ConfigurationService,
    public translationService: TranslationService,
    private dialogService: DialogService,
    private http: HttpService
  ) { }

  private readProject() {
    if (this.projectId == null) {
      this.project = null;
      return;
    }
    this.isLoading = true;
    this.http.postWithContext<Project>(environment.erpProjectEndpoint + '/getProject', { id: this.projectId }).subscribe(
      response => {
        console.log('response is', response);
        this.project = new Project(response);
        this.isLoading = false;
      }, error => {
        console.log('error is', error);
        this.isLoading = false;
      });
  }

  public onProjectChanged() {
    this.readProject();
  }

  addRootNode() {
    this.dialogService.openDefault(AddProjectPartDialogComponent, { projectId: this.project.id, parentPartId: null }).afterClosed().subscribe(() => {
      this.readProject();
    });
  }
}
